import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/landing/Nav";
import { Footer } from "@/components/landing/Footer";
import { StickyCTA } from "@/components/landing/StickyCTA";
import { CtaButton } from "@/components/landing/CtaButton";
import { Reveal, MaskLines } from "@/components/landing/Reveal";
import { FOREX_PAGES } from "@/constants/forexPages";

export default function ForexHub() {
  useLenis();
  useEffect(() => {
    document.title = "Forex Trading Coaching | Shabz Fazl — Forex Trading Coach";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App grain relative">
      <Nav />
      <main>
        <section className="relative overflow-hidden pb-16 pt-32 sm:pt-36">
          <div className="pointer-events-none absolute left-1/2 top-24 h-[55vh] w-[55vh] -translate-x-1/2 rounded-full opacity-[0.15] blur-3xl" style={{ background: "radial-gradient(circle, #d4af37, transparent 65%)" }} />
          <div className="mx-auto max-w-4xl px-6 text-center sm:px-8">
            <Reveal>
              <span className="mb-6 inline-flex items-center gap-3 font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">
                <span className="h-px w-8 bg-[#d4af37]" /> Forex Coaching
              </span>
            </Reveal>
            <h1 className="font-['Playfair_Display'] text-4xl font-semibold leading-[1.05] tracking-tight sm:text-6xl">
              <MaskLines className="block" lineClass="text-white-gold" lines={["Forex Trading Coaching"]} />
            </h1>
            <Reveal delay={0.15}>
              <p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-[#a1a1aa] sm:text-lg">
                Private, paid-only forex mentorship with Shabz Fazl — a forex trading coach the markets respect. Pick the area you want to master and message her on Instagram to apply.
              </p>
            </Reveal>
            <Reveal delay={0.3} className="mt-9 flex justify-center">
              <CtaButton testid="forex-hub-cta" />
            </Reveal>
          </div>
        </section>

        <section className="relative border-t border-white/10 py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {FOREX_PAGES.map((p, i) => (
                <Reveal key={p.slug} delay={(i % 3) * 0.08}>
                  <Link to={`/forex/${p.slug}`} data-testid={`hub-card-${p.slug}`} className="group block overflow-hidden border border-white/10 bg-[#0e0e10] transition-colors hover:border-[#d4af37]/40">
                    <div className="relative overflow-hidden">
                      <img src={p.img} alt={`${p.key} — Shabz Fazl`} className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0e0e10] to-transparent" />
                    </div>
                    <div className="flex items-center justify-between p-6">
                      <h2 className="font-['Playfair_Display'] text-xl capitalize text-[#f5f5f0] group-hover:text-[#d4af37]">{p.key}</h2>
                      <ArrowUpRight className="h-5 w-5 text-[#d4af37]" />
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
